export default __webpack_public_path__ + "static/media/competedDot.1b7e1a94.svg";